import axios from 'axios' //引入axios
// import qs from 'qs' //引入qs，用来序列化post类型的数据，否则后端无法接收到数据
// 设置post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json'
// axios.defaults.headers['app_id'] = 'com.supertools.dailynews'
axios.defaults.withCredentials = false //在跨域请求时，不会携带用户凭证；返回的 response 里也会忽略 cookie

//创建axios实例，请求超时时间为300秒
const instance = axios.create({
	timeout: 300000,
	baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
})
// 存储pengding请求容器
const pendingList = new Map()
// 生成各个请求标识
const getFetchKey = (config) => {
	if (!config) return ''
	const { url, data, method, params } = config
	if (!url || !method) return ''

	let token
	if (method === 'get') {
		token = [method, url, JSON.stringify(params)].join('&')
	} else {
		token = [method, url, JSON.stringify(data)].join('&')
	}
	return token
}
const addPending = (config) => {
	const fetchKey = getFetchKey(config)
	if (fetchKey) {
		config.cancelToken =
			config.cancelToken ||
			new axios.CancelToken((cancel) => {
				if (!pendingList.has(fetchKey)) {
					pendingList.set(fetchKey, cancel)
				}
			})
	}
}
// 移除pengding请求
const removePending = (config) => {
	const fetchKey = getFetchKey(config)
	if (fetchKey && pendingList.has(fetchKey)) {
		pendingList.delete(fetchKey)
	}
}
// 取消请求
const cancelPending = (config) => {
	const fetchKey = getFetchKey(config)
	if (fetchKey && pendingList.has(fetchKey)) {
		console.warn(`${config?.url}: 短时间内重复请求`)
		const cancel = pendingList.get(fetchKey)
		cancel('cancel')
		pendingList.delete(fetchKey)
	}
}

//请求和响应拦截可以根据实际项目需求进行编写
// 请求发起前拦截
instance.interceptors.request.use(
	(request) => {
		//这里可以对接口请求头进行操作 如：request.headers['X-Token'] = token
		// console.log('请求拦截', request)
		// console.log(request.headers)
		request.headers = { ...request.headers }
		// 发送请求前首先检查该请求是否已经重复，重复则进行取消并移除
		cancelPending(request)
		// 添加该请求到pendingList中
		addPending(request)

		return request
	},
	(error) => {
		return Promise.reject(error)
	},
)

// 响应拦截（请求返回后拦截）
instance.interceptors.response.use(
	(response) => {
		// console.log('响应拦截', response)
		removePending(response)
		return response.data
	},
	(error) => {
		removePending(error.response)
		return Promise.reject(error)
	},
)
//按照请求类型对axios进行封装
const service = {
	get(url, data) {
		console.log(data)
		// 提取headers和其他参数
		const { headers, ...params } = data || {}

		// 简化为直接发送到Node代理，url作为查询参数传递
		return instance.get('/api-proxy', {
			params: {
				url, // 传递原始URL
				...params, // 传递其他参数
			},
			headers, // 直接传递headers对象
		})
	},
	post(url, obj) {
		// 如果是API代理请求
		if (url === '/api-proxy') {
			console.log('API代理请求:', obj)

			// 提取headers和其他数据
			const { headers, method, params, url: apiUrl, host, ...otherData } = obj || {}

			// 构造请求参数
			const requestConfig = {
				headers: headers, // 直接传递headers对象
			}

			// 构造请求数据或查询参数
			if (method && method.toLowerCase() === 'get') {
				// GET请求，将params作为查询参数
				return instance.get('/api-proxy', {
					params: {
						url: apiUrl, // 传递API URL
						...params, // 传递查询参数
						host, // 传递host参数
					},
					...requestConfig, // 合并其他配置
				})
			} else {
				// POST或其他请求，将数据放在请求体中
				return instance.post(
					'/api-proxy',
					{
						...otherData, // 传递其他数据
						params, // 保留params
					},
					{
						params: {
							url: apiUrl, // 传递API URL
							host, // 传递host参数
							method, // 传递请求方法
						},
						...requestConfig, // 合并其他配置
					},
				)
			}
		}

		// 普通POST请求
		// 提取headers和其他数据
		const { headers, ...data } = obj || {}

		return instance.post(url, data, { headers })
	},
}
export { service }
